import * as React from "react";
import { Dimmer, Loader } from "semantic-ui-react";

interface SpinnerProps {
  loading: boolean;
  loadingText: string;
}
const Spinner: React.FunctionComponent<SpinnerProps> = props =>
  props.loading ? (
    <Dimmer active={props.loading} inverted>
      <Loader content={props.loadingText} />
    </Dimmer>
  ) : null;

export default Spinner;
